import React, { useState } from "react";
import ToastContext from "./ToastContext";
import ToastPortal from "./ToastPortal";
var ToastProvider = function ToastProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    activeToast = _useState[0],
    setActiveToast = _useState[1];
  var _useState2 = useState(null),
    requestClose = _useState2[0],
    setRequestClose = _useState2[1];
  var removeToast = function removeToast() {
    activeToast == null ? void 0 : activeToast.onClose == null ? void 0 : activeToast.onClose();
    setActiveToast(null);
  };
  var addToast = function addToast(newToast) {
    if (activeToast) {
      setRequestClose(function () {
        return function () {
          removeToast();
          setRequestClose(null);
          setActiveToast(newToast);
        };
      });
    } else {
      setActiveToast(newToast);
    }
  };
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: {
      addToast: addToast,
      removeToast: removeToast
    }
  }, children, activeToast && /*#__PURE__*/React.createElement(ToastPortal, {
    activeToast: activeToast,
    requestClose: requestClose
  }));
};
export default ToastProvider;